import { z } from 'zod';
import { requiredString } from '../helpers';
export const Hubspot_Get_Tickets_2_ConfigValidator = z
    .object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    contactEmail: z.string().optional(),
    contactPhoneNumber: z.string().optional(),
    propertyFilters: z
        .array(z.object({
        propertyName: requiredString('Property name is required'),
        value: requiredString('Property value is required')
    }))
        .optional(),
    pipelineId: z.string().nullable().optional(),
    additionalProperties: z.string().optional(),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true;
        try {
            JSON.parse(val);
            return true;
        }
        catch {
            return false;
        }
    }, { message: 'Expected output must be valid JSON' })
})
    .refine((data) => {
    const hasEmail = !!data.contactEmail?.trim();
    const hasPhone = !!data.contactPhoneNumber?.trim();
    const hasProperties = !!data.propertyFilters?.length;
    return (hasEmail || hasPhone || hasProperties) && !(hasEmail && hasPhone);
}, {
    path: ['contact'],
    message: 'Please fill in Email, Phone Number, or Property Filters'
})
    .refine((data) => {
    const hasContact = !!data.contactEmail?.trim() || !!data.contactPhoneNumber?.trim();
    const filterCount = (hasContact ? 1 : 0) + (data.pipelineId ? 1 : 0) + (data.propertyFilters?.length || 0);
    return filterCount <= 6;
}, {
    path: ['propertyFilters'],
    message: 'HubSpot allows a maximum of 6 filters per search.'
});
//# sourceMappingURL=hubspot-get-tickets-2.js.map